module.exports = __webpack_public_path__ + "assets/img/33t.fed0e6b3.png";